import axios from 'axios'
import showToastify from '../utils/toastify'
import 'toastify-js/src/toastify.css'
import { find } from "utils/dom"
import IMask from 'imask';

export default function () {
	const Contato = find("[js-page='contato']")
	if (!Contato) return

	console.log('Page contato');

	
	const element = document.querySelector('#form-contato input[name=telefone]')
	const maskOptions = {
		mask: [
			{
				mask: '(00) 0000-0000',
			},
			{
				mask: '(00) 00000-0000',
			},
		],
	}

	const maskContato = IMask(element, maskOptions)

	const changePdf = () => {
		const input = document.getElementById("arquivo");
		const fileName = document.getElementById("file-name");
		const textPDF = document.querySelector('.text-pdf')

		input.addEventListener("change", () => {
			if (input.files.length > 0) {
			const file = input.files[0];

			// Validação PDF (MIME ou extensão)
			if (file.type !== "application/pdf" && !file.name.endsWith(".pdf")) {
				textPDF.classList.remove('hidden')
				input.value = "";
				fileName.textContent = "Nenhum arquivo selecionado";
				return;
			}

			fileName.textContent = file.name;
			textPDF.classList.add('hidden')
			
			} else {
			fileName.textContent = "Nenhum arquivo selecionado";
			}
		});
	}

	//changePdf()

document.addEventListener("DOMContentLoaded", () => {
  const dropArea = document.getElementById("drop-area");
  const fileInput = document.getElementById("arquivo");
  const fileName = document.getElementById("file-name");
  const errorMsg = document.querySelector(".text-pdf");

  ["dragenter", "dragover", "dragleave", "drop"].forEach(eventName => {
    dropArea.addEventListener(eventName, e => {
      e.preventDefault();
      e.stopPropagation();
    });
  });

  ["dragenter", "dragover"].forEach(eventName => {
    dropArea.addEventListener(eventName, () => {
      dropArea.classList.add("ring-2", "ring-primary-50");
    });
  });

  ["dragleave", "drop"].forEach(eventName => {
    dropArea.addEventListener(eventName, () => {
      dropArea.classList.remove("ring-2", "ring-primary-50");
    });
  });

	dropArea.addEventListener("drop", e => {
    const file = e.dataTransfer.files[0];
    if (file) {
      fileInput.files = e.dataTransfer.files; // associa ao input
      fileName.textContent = `📄 ${file.name}`;
      errorMsg.classList.add("hidden"); // esconde mensagem de erro (se existir)
    }
  });

  fileInput.addEventListener("change", () => {
    const file = fileInput.files[0];
    if (file) {
      fileName.textContent = `📄 ${file.name}`;
      errorMsg.classList.add("hidden");
    }
  });
});


function showMessage(response) {
		const message = response.data ? response.data.message : response.message
		showToastify(message)
		contatoFormSubmit.reset()
		const fileName = document.getElementById("file-name");
		if (fileName) {
			fileName.textContent = "Solte ou arraste o arquivo.";
		}
		setTimeout(enabledBtn, 1000)
}

const btnSubmit = document.querySelector('#form-contato button[type=submit]')

function disabledBtn() {
		btnSubmit.disabled = true
		btnSubmit.classList.add('disabled')
}

function enabledBtn() {
		btnSubmit.disabled = false
		btnSubmit.classList.remove('disabled')
}


const contatoFormSubmit = document.querySelector('#form-contato');

contatoFormSubmit &&
		contatoFormSubmit.addEventListener('submit', function (event) {
				event.preventDefault()
				disabledBtn()

				const formElement = document.querySelector('#form-contato');
				const formData = new FormData(formElement);
				const jsonData = Object.fromEntries(formData.entries());
				

				const url = '/fale-conosco/'

				axios
						.post(url, jsonData,{
							  headers: {
									'Content-Type': 'multipart/form-data'
								}
						})
						.then((response) => showMessage(response))
						.catch((response) => showMessage(response))
		})


}
